import React, { useEffect } from "react";
import RenderModal from "../../../components/renderModal";
import * as S from "./styles";

const ModalConfirmStart = ({
  isOpen,
  loading,
  icon = "⏱",
  title = "Bora começar?",
  description = "O cronômetro de 4 horas dispara agora e não para — nem se você fechar a aba. Comece só quando estiver num momento tranquilo.",
  confirmLabel = "SIM, COMEÇAR AGORA",
  cancelLabel = "Ainda não",
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape" && onCancel) onCancel();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && onCancel) onCancel();
  };

  return (
    <RenderModal>
      <S.Overlay onClick={handleOverlayClick}>
        <S.Card role="dialog" aria-modal="true" aria-label={title}>
          <S.IconCircle aria-hidden="true">{icon}</S.IconCircle>
          <S.Title>{title}</S.Title>
          <S.Description>{description}</S.Description>
          <S.Actions>
            <S.ConfirmButton
              type="button"
              onClick={onConfirm}
              disabled={loading}
            >
              {confirmLabel}
            </S.ConfirmButton>
            <S.CancelButton
              type="button"
              onClick={onCancel}
              disabled={loading}
            >
              {cancelLabel}
            </S.CancelButton>
          </S.Actions>
        </S.Card>
      </S.Overlay>
    </RenderModal>
  );
};

export default ModalConfirmStart;
